// extracted by mini-css-extract-plugin
module.exports = {"imagesGrid":"masonry_imagesGrid__jhncJ","column":"masonry_column__3RT3d"};